import './App.css';
import Header from './Componants/Header';
import Home from './Componants/Home';
import Footer from './Componants/Footer';


function App() {
  return (
    <div>
      <Header/>
      <Home/>
      <Footer/>
    </div>
  );
}

export default App;
